import { Avatar } from 'avatar-components';
import { View } from 'foundations-components/transitional/components/View';
import useUnifiedEventSubmittedUser from '../../hooks/useUnifiedEventSubmittedUser';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ApprovalUnifiedSubmittedUserAvatar(props) {
  const {
    event
  } = props;
  const eventOwner = useUnifiedEventSubmittedUser(event);
  if (!eventOwner) {
    return null;
  }
  return /*#__PURE__*/_jsx(View, {
    inlineSize: "32px",
    children: /*#__PURE__*/_jsx(Avatar, {
      size: "responsive",
      hubSpotUserEmail: eventOwner.email,
      displayName: eventOwner.email
    })
  });
}